import React from 'react';
import { colors, typography } from '../../../theme';
import { formatTime } from '../../utils/format-time';

const MIN_TICK_SPACING = 64;
const RULER_HEIGHT = 28;

type TimelineRulerProps = {
  totalDuration: number;
  pxPerSecond: number;
  trackWidth: number;
  startOffset: number;
  onScrubStart?: (e: React.MouseEvent) => void;
};

const getTickInterval = (pxPerSecond: number): number => {
  const intervals = [500, 1000, 2000, 5000, 10000, 30000, 60000, 120000];
  for (const interval of intervals) {
    const spacing = (interval / 1000) * pxPerSecond;
    if (spacing >= MIN_TICK_SPACING) return interval;
  }
  return intervals[intervals.length - 1];
};

export const TimelineRuler: React.FC<TimelineRulerProps> = ({
  totalDuration,
  pxPerSecond,
  trackWidth,
  startOffset,
  onScrubStart
}) => {
  if (trackWidth === 0) return null;

  const safeTotal = Math.max(totalDuration, 1000);
  const interval = getTickInterval(pxPerSecond);

  const ticks: { ms: number; px: number }[] = [];
  for (let ms = 0; ms <= safeTotal; ms += interval) {
    ticks.push({ ms, px: (ms / 1000) * pxPerSecond });
  }

  return (
    <div
      onMouseDown={onScrubStart}
      style={{
        position: 'relative',
        height: RULER_HEIGHT,
        minHeight: RULER_HEIGHT,
        borderBottom: `1px solid ${colors.border}`,
        userSelect: 'none',
        cursor: onScrubStart ? 'pointer' : 'default'
      }}
    >
      {ticks.map(tick => (
        <div
          key={tick.ms}
          style={{
            position: 'absolute',
            left: tick.px + startOffset,
            top: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <span
            style={{
              fontSize: typography.fontSize.sm,
              color: colors.textMuted,
              marginLeft: 4
            }}
          >
            {formatTime(tick.ms)}
          </span>
        </div>
      ))}
    </div>
  );
};
